import { getLocale, isLocale, type Locale, matchLocale, setLocale } from "@t3tools/shared/i18n";

const STORAGE_KEY = "zwrm:language";

/** The language picked in Settings, or null to follow the browser. */
export function readLanguagePreference(): Locale | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return isLocale(value) ? value : null;
  } catch {
    return null;
  }
}

/** Saves the picked language (null follows the browser) and reloads into it. */
export function changeLanguage(locale: Locale | null): void {
  try {
    if (locale) localStorage.setItem(STORAGE_KEY, locale);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
  location.reload();
}

/** The browser's preferred languages, best first. */
export function browserLanguages(): ReadonlyArray<string> {
  return navigator.languages?.length ? navigator.languages : [navigator.language];
}

/** Sets the app's language at startup; see ./boot.ts. */
export function bootLanguage(): void {
  const languages = browserLanguages();
  setLocale(readLanguagePreference() ?? matchLocale(languages), languages[0]);
  document.documentElement.lang = getLocale();
  // Text is picked once at load, so a language changed in another window of
  // this app takes effect here by reloading too.
  window.addEventListener("storage", (event) => {
    if (event.key === STORAGE_KEY) location.reload();
  });
}
